export const DEFAULT_ASSET_BASE =
  "https://fv-assets.mlb.com/v/0fbe88d85d72da511f18dc7fee93a67914ddd302";
